module.exports = "<div [formGroup]=\"formGroup\">\n  <ng-container #sectionContainer ></ng-container>\n</div>\n"